import React from "react";
import AvailabilityPage from "../../../availabilityDoctor/pages/availabilityPage/availabilityPage";
import AppLayoutAssistant from "../../../navigation/Layout/LayoutAssistant";
import useAssistantDoctorId from "../../hooks/useAssistantDoctorId";

export default function AssistantAvailabilityPage() {
  const doctorId = useAssistantDoctorId();

  return (
    <AvailabilityPage
      LayoutComponent={AppLayoutAssistant}
      disableRemote={!doctorId}
      localEvents={[]}
      localSlots={[]}
      medecinIdOverride={doctorId}
    />
  );
}
